<loader-overlay-component [show]="isloading"></loader-overlay-component>
<div class="dmv-payment inner-home">
    <div class="container">
      <div class="row no-margin">
        <!--heading section starts here-->
        <div class="col-6 col-sm-2 mt-4 ">
          <a >
             <button class="btn btn-primary btn-back top-back-button"
              (click)="goBack()"><i class="fa fa-chevron-left text-left" ></i> Back</button>
          </a>  
        </div>
  
        <div class="col-12 col-sm-8 mt-4">
          <div id="searchResu">Request a Duplicate Registration</div>
          <p id="addthereco">&nbsp; </p>
        </div>
  
  
        <div class="col-6 col-sm-2 icon-cart mt-4">
          <dmv-shoping-cart [registrationsInCart]="dmvStoreService?.registrationsInCart?.dmvRegistrations" [registrationsManual]="dmvStoreService?.registrationsInCart?.dmvRegistrationsManual"  (clickEvent)="moveToRegistration($event)"></dmv-shoping-cart>
        </div>
  
        <!--heading section ends here-->
  

        <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
         {{errorMessage}}
        </div>
        <div class="alert alert-info" *ngIf="infoMessage">
            &nbsp;{{infoMessage}}
          </div>
        
        <form class="row mt-4 withForIe" autocomplete="off"  style="display: contents;" [formGroup]="manualRenewForm">
             <div class="asteriskMessage" >
         *Fields marked with an asterisk are required
        </div>

        <div class="col-12 col-sm-6 p-0 m-auto">
            <div class="col-12 col-sm-12 ">
                <div class="form-group">
                    <div id="firstName">Vechicle Type*</div>
                        <div class="select-wrapper-2 monthpicker m-auto">                      
                            <select #vechicleTypeEle (click)="selectChange($event)" (keydown)="selectChangeByKey($event)" (change)="changeType($event)"  (blur)="setDownIcon($event)" formControlName="vechicleType" class="form-control" required="required" [ngClass]="{ 'is-invalid': submitted && f.vechicleType.errors }" [value]="vechicleType"  >
                                        <option value="" [selected]="vechicleType===''">Select One</option>
                                        <option [value]="item.registrationType" *ngFor="let item of dmvRegistrationTypes" [selected]="vechicleType===item.registrationType" >{{item.name}}</option>
                            </select>                           
                            <div class="invalid-feedback">Example invalid select vehicle type</div>
                        </div>
                </div>
            </div>  
                
            <div class="col-12 col-sm-12">
                <div class="form-group">
                    <div id="firstName">{{dmvStoreService.agencyConfig?.agencyDmvConfig?.licensePlateSearchLabel}}*</div>
                    <input type="text" (blur)="globalService.trimValue(f.tagNumber)" maxlength="15" class="form-control" formControlName="tagNumber" name="tagNumber" [ngClass]="{ 'is-invalid': submitted && f.tagNumber.errors }"> 
                    <div class="invalid-feedback" *ngIf="f.tagNumber.errors?.required">Please provide a valid {{dmvStoreService.agencyConfig?.agencyDmvConfig?.licensePlateSearchLabel}}.</div>
                    <div class="invalid-feedback" *ngIf="f.tagNumber.errors?.pattern">No symbols allowed except space and hyphen</div>
                </div>
            </div>            

            
            <div class="col-12 col-sm-12">
            <div class="form-group">
                <label for="expirationDate" class="lblPin">EXPIRATION DATE (mm/dd/yyyy)*</label>
                    
                        <input [textMask]="{mask: mask}"  type="text" formControlName="expirationDate" class="form-control" placeholder="mm/dd/yyyy"
                                data-date-format="mm/dd/yyyy" id="expirationDate"
                                [ngClass]="{ 'is-invalid': submitted && f.expirationDate.errors }">
                            
                            <div *ngIf="submitted && f.expirationDate.errors" class="invalid-feedback">
                                <div *ngIf="f.expirationDate.errors.required">Please enter expiration date</div>
                                <div *ngIf="f?.expirationDate?.errors?.invalid">Invalid expiration date</div>
                                <div *ngIf="f.expirationDate.errors.pattern">Date must be in mm/dd/yyyy format</div>
                            </div>           
                    
                    
                </div>
            </div>
        </div>
        
        <div class="col-12 col-sm-6" *ngIf="dmvCostData">
            <div class="col-12" id="iTEMSUMMAR">
                COST
            </div>

            <div class="row no-margin">
                <div class="col-6" id="onYearRene"> Renewal Cost </div>
                <div class="col-6" id="moneyTxt"> {{dmvCostData?.renewalCost | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}
                </div>
            </div>
            <div class="row no-margin" *ngFor="let dmvFee of dmvCostData?.dmvFees">
                <div class="col-6" id="onYearRene"> {{dmvFee.description}} </div>
                <div class="col-6" id="moneyTxt"> {{dmvFee?.amount | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}
                </div>
            </div>
            <div class="row no-margin">
                <div class="col-6" id="onYearRene"> TOTAL </div>
                <div class="col-6" id="moneyTxt"> {{dmvCostData?.totalAmountDue | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}
                </div>
            </div>

        </div>

            
            


             
            
                  
            
           
        </form>

        
      </div>
  
      <div class="m-auto text-center" >
                  <a >
                        <button class="btn btn-primary btn-back" (click)="goBack()"><i class="fa fa-chevron-left text-left"></i> Back</button>
                    </a>                  
                <a >
                    <button [disabled]="!(f?.vechicleType?.value && f?.tagNumber?.value && f?.expirationDate?.value)?'disabled':null" class="btn btn-primary btn-continue  m-auto" [ngClass]="{'disabled': !(f?.vechicleType?.value && f?.tagNumber?.value && f?.expirationDate?.value) }" (click)="continue()">Continue <i class="fa fa-chevron-right text-right"></i></button>
                </a>
            </div>  
  
  
    </div>
  </div>